import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getCustomerAddresses } from 'src/api/customer/addresses';
import {
    FETCH_CUSTOMER_ADDRESSES,
    requestCustomerAddresses,
    requestCustomerAddressesFailure,
    requestCustomerAddressesSuccess,
} from './actions';

/* Customer Addresses */
function* fetchCustomerAddressesSaga(action: AnyAction): SagaIterator {
    yield put(requestCustomerAddresses());

    const { error, response } = yield call(getCustomerAddresses);

    if (error) yield put(requestCustomerAddressesFailure(error));
    else yield put(requestCustomerAddressesSuccess(response));
}

export function* generateFetchCustomerAddressesWatcher() {
    yield takeLatest(FETCH_CUSTOMER_ADDRESSES, fetchCustomerAddressesSaga);
}
